import { render, staticRenderFns } from "./CashCollectionComponent.vue?vue&type=template&id=720fe93f"
import script from "./CashCollectionComponent.vue?vue&type=script&lang=js"
export * from "./CashCollectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports